module.exports = "/images/history_white.svg?2a283c2f511379589bd83707bdb02439";